import React, {useEffect, useState} from 'react';
import {navigate} from 'gatsby';
import {useQuery} from '@apollo/react-hooks';
import {useMediaQuery} from 'react-responsive';
import {GET_USER_WATCH_SETTINGS_QUERY} from '../../../graphql/queries';
import CustomModal from '../../customModal';
import PricingCard from '../pricing-card';
import EnterpriseForm from '../../enterprice-form';
import Button from '../../button';
import {getUserToken} from '../../../helpers';
import {checkedCircleIcon, closeIcon} from '../../../images/svgIcons';
import pricingIcon from '../../../images/pricing/pricing-hint.png';
import integrations from '../../../images/integrations/integrations_2.png';

import './styles.scss';

export const business = [
  {
    isBold: true,
    text: 'All the benefits of Pro, plus:',
  },
  {
    number: 10000,
    text: <>Checks per month</>,
  },
  {
    number: '5 min',
    text: 'Monitoring checks frequency (max)',
  },
  {
    number: '3h',
    text: 'Sitemap monitoring',
  },
  {
    isChecked: true,
    text: 'Server location',
  },
  {
    isChecked: true,
    text: 'Integrations',
  },
  {
    text: (
      <div style={{marginLeft: '-36px'}}>
        <img src={integrations} alt="Integrations" className="mt-2" />
      </div>
    ),
  },
];

const enterPrise = [
  {
    isBold: true,
    text: 'All the benefits of Business+, plus:',
  },

  {
    isChecked: true,
    text: 'Personalized onboarding',
  },
  {
    isChecked: true,
    text: 'Team training',
  },

  {
    isChecked: true,
    text: 'Campaign setup and management',
  },
  {
    isChecked: true,
    text: 'Dedicated strategy consultant',
  },
];

export const hexowatchPackages = (name: string, details?: boolean) => {
  const obj = {
    PRO: [
      {
        number: 4500,
        text: <>Checks per month</>,
      },
      {
        number: '15 min',
        text: 'Monitoring checks frequency (max)',
      },
      {
        number: '6h',
        text: 'Sitemap monitoring',
      },
      {
        isChecked: true,
        text: <div>Access all monitoring types</div>,
      },
      {
        isChecked: true,
        text: (
          <>
            Access residential proxies <br />
            (requires premium credits)
          </>
        ),
      },
    ],
    BUSINESS: details
      ? [
          {
            number: 10000,
            text: <>Checks per month</>,
          },
          {
            number: '5 min',
            text: 'Monitoring checks frequency (max)',
          },
          {
            number: '3h',
            text: 'Sitemap monitoring',
          },
          {
            isChecked: true,
            text: <div>Access all monitoring types</div>,
          },
          {
            isChecked: true,
            text: (
              <>
                Access residential proxies <br />
                (requires premium credits)
              </>
            ),
          },
          {
            isChecked: true,
            text: <div>Server location</div>,
          },
          {
            isChecked: true,
            text: 'Integrations',
          },
          {
            text: (
              <div style={{marginLeft: '-36px'}}>
                <img src={integrations} alt="Integrations" className="mt-2" />
              </div>
            ),
          },
        ]
      : business,

    'BUSINESS+': details
      ? [
          {
            number: 25000,
            text: <>Checks per month</>,
          },
          {
            number: '5 min',
            text: 'Monitoring checks frequency (max)',
          },
          {
            number: '3h',
            text: 'Sitemap monitoring',
          },
          {
            isChecked: true,
            text: <div>Access all monitoring types</div>,
          },
          {
            isChecked: true,
            text: (
              <>
                Access residential proxies <br />
                (requires premium credits)
              </>
            ),
          },
          {
            isChecked: true,
            text: <div>Server location</div>,
          },
          {
            isChecked: true,
            text: 'Integrations',
          },
          {
            text: (
              <div style={{marginLeft: '-36px'}}>
                <img src={integrations} alt="Integrations" className="mt-2" />
              </div>
            ),
          },
          {
            isChecked: true,
            text: 'API/Webhooks',
          },
        ]
      : [
          {
            isBold: true,
            text: 'All the benefits of Business, plus:',
          },
          {
            number: 25000,
            text: 'Checks per month',
          },
          // {
          //   select: true,
          //   text: '',
          //   options: selectOptions,
          // },
          {
            isChecked: true,
            text: 'API/Webhooks',
          },
        ],
  };
  //@ts-ignore
  return obj[name];
};

const PricingPackeges = ({
  interval,
  products,
  promo,
  LTD,
  setAnnual,
  showAnnualDiscountPlans,
  specialLtd,
}: {
  products: any;
  interval: 'monthly' | 'ltd' | 'annual';
  promo?: boolean;
  LTD?: boolean;
  promoPage?: boolean;
  goldSpecial?: boolean;
  promoUser?: boolean;
  setAnnual?: any;
  showAnnualDiscountPlans?: boolean;
  specialLtd?: boolean;
}) => {
  //-----------------------State--------------------------
  const isMobile = useMediaQuery({maxWidth: 1199});
  const [showAll, setShowAll] = useState(false);
  const [currentPackage, setCurrentPackage] = useState('');
  const [currentPackageInterval, setCurrentPackageInterval] = useState('');
  const [canUseTrial, setCanUseTrial] = useState(true);
  const [trialPlans, setTrialPlans] = useState(['PRO']);
  const [user, setUser] = useState<any>(null);
  const [verified, setVerified] = useState(false);
  const [showUpgradeContact, setShowUpgradeContact] = useState(true);
  const [showEnterpriseModal, setShowEnterpriseModal] = useState(false);
  const [showSentMsg, setShowSentMsg] = useState(false);
  const [pendingPayment, setPendingPayment] = useState(false);
  const [showLtd, setShowLtd] = useState(false);
  const [showAnnualDiscount, setShowAnnualDiscount] = useState(false);

  const [packages, setPackages] = useState<any>({
    annual: [],
    monthly: [],
    ltd: [],
  });

  const [updatedPackages, setUpdatedPackages] = useState<any>({
    annual: [],
    monthly: [],
    ltd: [],
  });

  const {data: hexowatchUserInfo, loading, refetch} = useQuery(GET_USER_WATCH_SETTINGS_QUERY, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    const hexUser = hexowatchUserInfo && hexowatchUserInfo.UserWatchSettings && hexowatchUserInfo.UserWatchSettings.get;
    if (showAnnualDiscountPlans) {
      setShowAnnualDiscount(true);
      setAnnual && setAnnual(true);
    } else if (hexUser && !hexUser.id && showAnnualDiscountPlans) {
      setShowAnnualDiscount(true);
      setAnnual && setAnnual(true);
    } else {
      setShowAnnualDiscount(false);
      setAnnual && setAnnual(false);
    }
  }, [user, showAnnualDiscountPlans, currentPackageInterval, currentPackage]);

  useEffect(() => {
    if (getUserToken()) {
      refetch();
    }
  }, [getUserToken()]);

  useEffect(() => {
    if (hexowatchUserInfo && hexowatchUserInfo.UserWatchSettings && hexowatchUserInfo.UserWatchSettings.get) {
      setUser(hexowatchUserInfo.UserWatchSettings.get);
      setCurrentPackage(hexowatchUserInfo.UserWatchSettings.get.pricing_package);
      setCurrentPackageInterval(hexowatchUserInfo.UserWatchSettings.get.pricing_package_interval);
      typeof hexowatchUserInfo.UserWatchSettings.get.can_use_trial === 'boolean' &&
        setCanUseTrial(hexowatchUserInfo.UserWatchSettings.get.can_use_trial);
      hexowatchUserInfo.UserWatchSettings.get.trial_packages &&
        setTrialPlans(hexowatchUserInfo.UserWatchSettings.get.trial_packages);
      typeof hexowatchUserInfo.UserWatchSettings.get.pending_payment === 'boolean'
        ? setPendingPayment(hexowatchUserInfo.UserWatchSettings.get.pending_payment)
        : setPendingPayment(false);
    }
    if (LTD) {
      setShowLtd(true);
      setAnnual(true);
    } else {
      setShowLtd(false);
    }
    if (hexowatchUserInfo && hexowatchUserInfo.User && hexowatchUserInfo.User && hexowatchUserInfo.User.get) {
      setVerified(hexowatchUserInfo.User.get.verified);
      setUser({
        ...hexowatchUserInfo.UserWatchSettings.get,
        email: hexowatchUserInfo.User.get.email,
      });
    }
  }, [hexowatchUserInfo, LTD]);

  useEffect(() => {
    if (products) {
      const packages_annual = {};
      const packages_ltd = {};
      const packages = {};
      const paypal_packages_annual = {};
      const paypal_packages_ltd = {};
      const paypal_packages = {};
      let free = {};
      products.map((item: any) => {
        const annualDiscount = showAnnualDiscount && item.interval === 'ANNUAL';
        const checkPro = item.product_name === 'PRO' ? (specialLtd ? 99 : 175) : null;
        const checkBussiness = item.product_name === 'BUSINESS' ? (specialLtd ? 198 : 350) : null;
        const checkBussinessPlus = item.product_name === 'BUSINESS+' ? (specialLtd ? 297 : 590) : null;
        const el = {
          id:
            showLtd &&
            item.interval === 'ANNUAL' &&
            (item.product_name === 'PRO' || item.product_name === 'BUSINESS' || item.product_name === 'BUSINESS+')
              ? products.find(
                  (subItem: any) => subItem.interval === 'LTD' && subItem.product_name === item.product_name && (subItem.unit_amount === checkPro || subItem.unit_amount === checkBussiness || subItem.unit_amount === checkBussinessPlus),
                ).id
              : promo && item.interval === 'ANNUAL'
              ? products.find(
                  (subItem: any) =>
                    subItem.interval === 'ANNUAL_DISCOUNT' &&
                    subItem.product_name === item.product_name &&
                    subItem.productType === item.productType,
                ).id
              : annualDiscount
              ? products.find(
                  (subItem: any) =>
                    subItem.interval === 'ANNUAL_DISCOUNT_50' &&
                    subItem.product_name === item.product_name &&
                    subItem.productType === item.productType,
                )?.id
              : item.id,
          interval:
            showLtd &&
            item.interval === 'ANNUAL' &&
            (item.product_name === 'PRO' || item.product_name === 'BUSINESS' || item.product_name === 'BUSINESS+')
              ? 'LTD'
              : item.interval,
          paymentOption: item.product_name,
          frequency: item.max_frequency
            .replace('_MINUTE', 'min')
            .replace('_HOUR', 'h')
            .replace('_', ''),
          siteMapMonitor: item.description.sitemap_monitor
            ? item.description.sitemap_monitor
                .replace('_MINUTE', 'min')
                .replace('_HOUR', 'h')
                .replace('_', '')
            : '',
          price:
            promo && item.interval === 'ANNUAL'
              ? products.find(
                  (subItem: any) =>
                    subItem.interval === 'ANNUAL_DISCOUNT' && subItem.product_name === item.product_name,
                ).unit_amount
              : item.unit_amount,
          ltdPrice:
            showLtd &&
            item.interval === 'ANNUAL' &&
            (item.product_name === 'PRO' || item.product_name === 'BUSINESS' || item.product_name === 'BUSINESS+')
              ? products.find(
                  (subItem: any) => subItem.interval === 'LTD' && (subItem.unit_amount === checkPro || subItem.unit_amount === checkBussiness || subItem.unit_amount === checkBussinessPlus) && subItem.product_name === item.product_name,
                ).unit_amount
              : null,
          totalChecks: item.monthly_scans_limit,
          discountAnnual:
            item.interval === 'ANNUAL'
              ? products.find(
                  (subItem: any) =>
                    subItem.interval === 'ANNUAL_DISCOUNT' && subItem.product_name === item.product_name,
                ).unit_amount
              : null,
          annualDiscountPrice: annualDiscount
            ? products.find(
                (subItem: any) =>
                  subItem.interval === 'ANNUAL_DISCOUNT_50' &&
                  subItem.product_name === item.product_name &&
                  subItem.productType === item.productType,
              )?.unit_amount
            : null,
          lineThrough:
            showLtd &&
            item.interval === 'ANNUAL' &&
            (item.product_name === 'PRO' || item.product_name === 'BUSINESS' || item.product_name === 'BUSINESS+'),
          isPopular: item.isPopular,
          description: item.description,
          flag: item.product_name === 'BUSINESS',
          discount:
            item.interval === 'ANNUAL'
              ? item.product_name === 'STANDARD'
                ? 30
                : item.product_name === 'PRO'
                ? 40
                : item.product_name === 'BUSINESS'
                ? 50
                : item.product_name === 'BUSINESS+' && 55
              : null,
          real_price:
            item.interval === 'ANNUAL'
              ? products.find(
                  (subItem: any) => subItem.interval === 'MONTHLY' && subItem.product_name === item.product_name,
                ).unit_amount
              : null,
          pricingList: hexowatchPackages(item.product_name, false),
        };

        if (item.product_name === 'STANDARD') {
          el.disabled = currentPackage && currentPackage !== 'FREE' ? true : false;
        } else if (item.product_name === 'PRO') {
          el.disabled =
            currentPackage &&
            (currentPackage === 'PRO' ||
              currentPackage === 'BUSINESS_SCANS_10000' ||
              currentPackage.includes('BUSINESS_SCANS_'))
              ? true
              : false;
        } else if (item.product_name === 'BUSINESS') {
          el.disabled =
            (currentPackage && (currentPackage === 'BUSINESS_SCANS_10000' || currentPackage.includes('BUSINESS_SCANS_'))) || (currentPackageInterval === 'LTD' && !showLtd)
              ? true
              : false;
        } else if (item.product_name === 'BUSINESS+' && !(showLtd && item.interval === 'ANNUAL')) {
          el.disabled =
            (currentPackage && currentPackage !== 'BUSINESS_SCANS_10000' && currentPackage.includes('BUSINESS_SCANS_')) || (currentPackageInterval === 'LTD' && !showLtd)
              ? true
              : false;
        } else el.disabled = false;
        if (item.productType === 'PAYPAL') {
          if (item.interval === 'ANNUAL') paypal_packages_annual[item.product_name] = el;
          else if (item.interval === 'LTD') paypal_packages_ltd[item.product_name] = el;
          else if (item.interval === 'MONTHLY') paypal_packages[item.product_name] = el;
        } else {
          if (item.interval === 'ANNUAL') packages_annual[item.product_name] = el;
          else if (item.interval === 'LTD') packages_ltd[item.product_name] = el;
          else if (item.priceId === 'none') free = el;
          else if (item.interval === 'MONTHLY') packages[item.product_name] = el;
        }
      });
      const plans = LTD
        ? {
            annual: [
              // free,
              // {...packages_annual.STANDARD, paypal_id: paypal_packages_annual.STANDARD.id},
              {...packages_annual.PRO, paypal_id: paypal_packages_annual.PRO.id},
              {...packages_annual.BUSINESS, paypal_id: paypal_packages_annual.BUSINESS.id},
              {...packages_annual['BUSINESS+'], paypal_id: paypal_packages_annual['BUSINESS+'].id},
            ],
            ltd: [
              // free,
              // {
              //   ...packages_ltd.STANDARD,
              //   paypal_id: paypal_packages_ltd.STANDARD ? paypal_packages_ltd.STANDARD.id : null,
              // },
              {...packages_ltd.PRO, paypal_id: paypal_packages_ltd.PRO ? paypal_packages_ltd.PRO.id : null},
              {
                ...packages_ltd.BUSINESS,
                paypal_id: paypal_packages_ltd.BUSINESS ? paypal_packages_ltd.BUSINESS.id : null,
              },
              {
                ...packages_ltd['BUSINESS+'],
                paypal_id: paypal_packages_ltd['BUSINESS+'] ? paypal_packages_ltd['BUSINESS+'].id : null,
              },
            ],
            monthly: [
              // free,
              // {...packages.STANDARD, paypal_id: paypal_packages.STANDARD.id},
              {...packages.PRO, paypal_id: paypal_packages.PRO.id},
              {...packages.BUSINESS, paypal_id: paypal_packages.BUSINESS.id},
              {...packages['BUSINESS+'], paypal_id: paypal_packages['BUSINESS+'].id},
            ],
          }
        : {
            annual: [
              // free,
              // {...packages_annual.STANDARD, paypal_id: paypal_packages_annual.STANDARD.id},
              {...packages_annual.PRO, paypal_id: paypal_packages_annual.PRO.id},
              {...packages_annual.BUSINESS, paypal_id: paypal_packages_annual.BUSINESS.id},
              {...packages_annual['BUSINESS+'], paypal_id: paypal_packages_annual['BUSINESS+'].id},
            ],
            ltd: [
              // free,
              // {
              //   ...packages_ltd.STANDARD,
              //   paypal_id: paypal_packages_ltd.STANDARD ? paypal_packages_ltd.STANDARD.id : null,
              // },
              {...packages_ltd.PRO, paypal_id: paypal_packages_ltd.PRO ? paypal_packages_ltd.PRO.id : null},
              {
                ...packages_ltd.BUSINESS,
                paypal_id: paypal_packages_ltd.BUSINESS ? paypal_packages_ltd.BUSINESS.id : null,
              },
              {
                ...packages_ltd['BUSINESS+'],
                paypal_id: paypal_packages_ltd['BUSINESS+'] ? paypal_packages_ltd['BUSINESS+'].id : null,
              },
            ],
            monthly: [
              // free,
              // {...packages.STANDARD, paypal_id: paypal_packages.STANDARD.id},
              {...packages.PRO, paypal_id: paypal_packages.PRO.id},
              {...packages.BUSINESS, paypal_id: paypal_packages.BUSINESS.id},
              {...packages['BUSINESS+'], paypal_id: paypal_packages['BUSINESS+'].id},
            ],
          };
      setPackages(plans);
      let localPlans = {...plans};
      if (canUseTrial && trialPlans.includes('PRO') && interval !== 'annual') {
        const monthlyArr = localPlans.monthly ? [...localPlans.monthly] : [];
        let indexOfPro = 0;
        monthlyArr.find((sub, index) => sub.paymentOption === 'PRO' && (indexOfPro = index));
        monthlyArr.splice(indexOfPro, 0, {
          ...packages.PRO,
          paypal_id: paypal_packages.PRO.id,
          trial: true,
          paymentOption: 'PRO (7-day free trial)',
        });
        localPlans = {
          ...localPlans,
          monthly: monthlyArr,
        };
      }
      setUpdatedPackages(localPlans);
    }
  }, [products, currentPackage, canUseTrial, trialPlans, showLtd, interval, currentPackageInterval, specialLtd]);

  const handleCloseModal = () => setShowUpgradeContact(false);

  return (
    <div className="pricing-packages-wrapper position-relative">
      {/* <Square size="small" className="small-element-position" /> */}
      {/* <Square size="medium" className="medium-element-position" />
      <Square size="large" className="large-element-position" /> */}
      {showUpgradeContact &&
        ((user && user.pricing_package_interval === 'LTD') ||
          (user &&
            user.pricing_package &&
            user.pricing_package.includes('BUSINESS_SCANS') &&
            user.pricing_package !== 'BUSINESS_SCANS_10000')) &&
        !showLtd &&
        interval === 'annual' && (
          <div className="text-center all-disabled">
            <span onClick={handleCloseModal}>{closeIcon}</span>
            <img src={pricingIcon} alt="icon" />
            <div>Need to upgrade your plan? </div>
            <div className="support">
              Please contact{' '}
              <a
                href="mailto:support@hexowatch.com"
                className="color-hexomatic"
                aria-label={'mail'}
                target="_blank"
                rel="noopener"
              >
                support@hexowatch.com
              </a>
              {'.'}
            </div>
          </div>
        )}
      <div className="pricing-cards-main-wrapper">
        {packages[interval].map((item: any) => (
          <div
            className={`inner-wr ${
              item.paymentOption === 'FREE' && !showEnterpriseModal && !showSentMsg ? 'z_index_2' : ''
            }`}
          >
            <PricingCard
              trigger={interval === 'ltd' ? item.price : undefined}
              name={item.paymentOption[0] + item.paymentOption.slice(1).toLowerCase()}
              price={item.price}
              lineThrough={item.lineThrough}
              flag={item.flag}
              pricingList={item.pricingList}
              ltdPrice={item.ltdPrice}
              showLtd={showLtd}
              annualDiscountPrice={item.annualDiscountPrice}
              showAnnualDiscount={showAnnualDiscount}
              disabled={
                item.disabled ||
                loading ||
                !user ||
                (interval === 'annual'
                  ? user?.paypal_subscription_id &&
                    user?.pricing_package === 'GOLD' &&
                    user?.pricing_package_interval === 'ANNUAL'
                  : user?.paypal_subscription_id && user?.pricing_package === 'GOLD')
              }
              user={user}
              packeges={updatedPackages[interval]}
              interval={interval}
              verified={verified}
              id={item.id}
              refetch={refetch}
              promo={promo}
              discountAnnual={promo ? item.discountAnnual : null}
              real_price={item.real_price}
              paypal_id={item.paypal_id}
              currentPlan={currentPackage}
              currentPlanInterval={currentPackageInterval}
              pendingPayment={pendingPayment}
              totalChecks={item.totalChecks}
              frequency={item.frequency}
              siteMapMonitor={item.siteMapMonitor}
              specialLtd={specialLtd}
            />
          </div>
        ))}
        <div className={`inner-wr ${!showEnterpriseModal && !showSentMsg ? 'z_index_2' : ''}`}>
          <PricingCard
            trigger={0}
            name="Enterprise"
            price={0}
            lineThrough={false}
            flag={undefined}
            handleEnterpriseClick={() => navigate('/enterprise')}
            pricingList={enterPrise}
            disabled={false}
            user={user}
            isEnterprise
            packeges={updatedPackages[interval]}
            interval={interval}
            verified={verified}
            showLtd={showLtd}
            showAnnualDiscount={showAnnualDiscount}
            id={'Enterprise'}
            refetch={refetch}
            promo={promo && interval === 'annual'}
            discountAnnual={null}
            specialLtd={specialLtd}
          />
        </div>
      </div>

      {showEnterpriseModal && (
        <CustomModal setShowPopup={setShowEnterpriseModal} noNavigate className="enterprise-popup">
          <EnterpriseForm setShowSentMsg={setShowSentMsg} onCLick={() => setShowEnterpriseModal(false)} />
        </CustomModal>
      )}

      {showSentMsg && (
        <CustomModal noCloseIcon>
          <div>
            <div className="d-flex mt-5 flex-column align-items-center justify-content-center">
              <div className="check-icon">{checkedCircleIcon}</div>
              <div className="mt-3">
                <strong>Message has been successfully sent.</strong>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <Button primary className="mt_20 mb-2" onClick={() => setShowSentMsg(false)}>
                Close
              </Button>
            </div>
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default PricingPackeges;
